import { render } from "./PlaygroundView.vue?vue&type=template&id=45aff3e5&scoped=true"
import script from "./PlaygroundView.vue?vue&type=script&lang=js"
export * from "./PlaygroundView.vue?vue&type=script&lang=js"

import "./PlaygroundView.vue?vue&type=style&index=0&id=45aff3e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45aff3e5"]])

export default __exports__